import { NavLink } from 'react-router-dom';

interface RenderNavLinkProps {
  to: string;
  label: string;
  disabled?: boolean;
}

export const renderNavLink = ({ to, label, disabled = false }: RenderNavLinkProps): React.ReactNode => {
  return (
    <NavLink to={to} onClick={disabled ? (e) => e.preventDefault() : undefined}>
      {label}
    </NavLink>
  );
};
